import Swiper from 'swiper';
import { api } from '@cloudsuite/theme_library/scripts/helper';
const initCheckoutCustomerService = require('../customer/components/checkoutCustomerService');
import IMask from 'imask';
import './recommendation-products';
import './product-tree';
import './stars-onfocus';
import './grid-view';
import './basket-addons';
import './sticky-orderform';
import './form-blur';

function applyZipMask() {
    const shop = document.querySelector('[data-js-shopconstants]')?.getAttribute('data-shop-id');
    if (shop === '1') {
        const zipField = document.getElementById('zip');
        if (!zipField) return
        const maskOptions = { mask: '0000aa' };
        const mask = IMask(zipField, maskOptions);
    }
}
applyZipMask();

//const Swiper = require('swiper/js/swiper.min');
const { cssNumber } = require('jquery');

// Load basketitems sidebar basket
$('.js-load-basket').on('click', function(e) {

    const bp = $('[data-js="js-basket-items"]');
    const url = bp.attr('data-url');

    if (url) {
        let xhr = new XMLHttpRequest();
    
        xhr.open('GET', url);
        xhr.send();
    
        xhr.onload = function() {
            let responseObj = xhr.response;
            bp.html(responseObj);
        };
    }

});


$('.product').each(function () {
    var product = $(this),
        variants = product.find('.options-alt');

    // DISPLAY ALT IMAGE ON PRODUCT HOVER
    product.find('.image').hoverIntent(
        function () {
            $(this).find('.alt-image').show();
        },
        function () {
            $(this).find('.alt-image').hide();
        }
    );

    // SCROLL PRODUCT VARIANT IMAGES
    if (variants.length) {
        var ul = variants.find('>ul'),
            li = ul.find('>li');

        if (li.length > 3) {
            var arrow_left = variants.find('.arrow-left'),
                arrow_right = variants.find('.arrow-right'),
                total_moves = (li.length) - 3,
                shift_pixels = 5,
                variantScroll = function (direction) {
                    return direction == 'left' ? 83 : -83;
                },
                checkArrows = function () {
                    if (shift_pixels == 5) {
                        arrow_left.removeClass('active');
                    } else {
                        arrow_left.addClass('active');
                    }
                    if (total_moves == 0) {
                        arrow_right.removeClass('active');
                    } else {
                        arrow_right.addClass('active');
                    }
                };

            checkArrows();
            variants.on('click', '.arrow-left', function () {
                if (shift_pixels < 5) {
                    shift_pixels += variantScroll('left');
                    total_moves++;
                    ul.animate({
                        marginLeft: shift_pixels + 'px'
                    }, 500);
                    checkArrows();
                }
            }).on('click', '.arrow-right', function () {
                if (total_moves > 0) {
                    shift_pixels += variantScroll('right');
                    total_moves--;
                    ul.animate({
                        marginLeft: shift_pixels + 'px'
                    }, 500);
                    checkArrows();
                }
            });
        }

    }
});
$('.sidebar._review').on('click', '.btn-submit-review, .js-btn-submit-review', function (e) {
    var $this = $(this),
        modal = $(e.delegateTarget),
        form = $this.closest('form'),
        url = form.data('url'),
        data = form.serializeArray();

    // Add bullet data from inputs to form data
    var review_bullets = modal.find('.reviewbullets-container');
    if (review_bullets.length > 0) {
        var bullet_array = [],
            count = 1;
        review_bullets.each(function (i) {
            var type = $(this).hasClass('bullets-positive') ? 'positive' : 'negative';
            $(this).find('.inputs input').each(function (j, e) {
                var value = $(this).val();
                if (value != '') {
                    const bulletJsonString = `{"sequence":"${count}", "text":"${value}", "type": "${type}"}`;

                    bullet_array.push(bulletJsonString);
                    count++;
                }
            });
        });
        data.push({ name: "bullets", value: '[' + bullet_array.join(',') + ']' });
    }

    // Post form
    $.post(url, $.param(data), function (res) {
        var inputs = $('.js-review-form').find('input,textarea');
        inputs.parent('.form-group').removeClass('has-error');
        inputs.siblings('.help-block').text('');

        if (res.form_errors !== undefined) {
            $.each(res.form_errors, function (key, val) {
                var input = $('[name=' + key + ']');
                input.parent('.form-group').addClass('has-error');
                input.siblings('.help-block').text(val[0]);
            });
        } else {
            modal.find('.modal-body-form').hide();
            modal.find('.modal-body-success').show();
            modal.find('.sidebar-intro .title').text('Bedankt!')
            modal.find('.sidebar-intro .subtitle').text('Je review is verzonden');

            dataLayer.push({
                'productReviewScore': $('.sidebar._review [name="rating"]').val(),
                'productName': $('.sidebar._review .product_name').text(), // use same name as the name within event productDetails
                'event': 'leftProductReview'
            });
        }
    });
})

$(document).on('click', '[data-target="#tips-guidelines-content"]', function (e) {
    $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');
})

$(document).on('click', '[data-target="reviewSingle"]', function (e) {
    e.preventDefault();
    if ($(this).data('content')) {
        const review = $(this).data('content');
        const target = $('.sidebar._reviewSingle .content');
        const htmlContent = reviewTemplate
            .replace('[[ratingStars]]', reviewStars(review.rating))
            .replace('[[ratingDate]]', review.date)
            .replace('[[ratingUser]]', review.user)
            .replace('[[reviewBullets]]', reviewBullets(review.bullets))
            .replace('[[reviewContent]]', review.text);

        target.html($(htmlContent));
    }
});


const reviewStars = (rating) => {
    const maxStars = 5;
    const newRating = parseInt(Math.round(rating));
    const halfRating = parseInt(Math.ceil(rating - newRating));
    const leftOver = parseInt(Math.floor(maxStars - newRating - halfRating));
    let stars = '';
    for (let i = 0; i < newRating; i++) {
        stars += '<i class="fas fa-star review__star"></i>';
    }
    for (let i = 0; i < halfRating; i++) {
        stars += '<i class="fas fa-star-half-alt review__star"></i>';
    }
    for (let i = 0; i < leftOver; i++) {
        stars += '<i class="fal fa-star review__star"></i>';
    }
    return stars;
};
const reviewBullets = (bullets) => {
    const positiveBullets = bullets.filter((bullet) => bullet.type == "positive");
    const negativeBullets = bullets.filter((bullet) => bullet.type == "negative");
    let htmlBullets = '';
    positiveBullets.forEach(bullet => {
        let text = '';
        try {
            text = decodeURIComponent(bullet.text);
        } catch (e) {
            text = bullet.text;
        }
        htmlBullets += `
        <p class="review-bullet">
        <i style="color:green;vertical-align: middle;font-size: 6px; margin-right: 5px;" class="fas fa-circle"></i> 
        ${text}
        </p>
    `
    });
    negativeBullets.forEach(bullet => {
        let text = '';
        try {
            text = decodeURIComponent(bullet.text);
        } catch (e) {
            text = bullet.text;
        }
        htmlBullets += `
        <p class="review-bullet">
        <i style="color:red;vertical-align: middle;font-size: 6px; margin-right: 5px;" class="fas fa-circle"></i> 
        ${text}
        </p>
        `
    });
    return htmlBullets;
}   

const reviewTemplate = `
    <div class="review">
        <p class="review-stars">[[ratingStars]]</p>
        <p class="review-date">[[ratingDate]] | [[ratingUser]]</p>
        [[reviewBullets]]
        
        <div class="review-contents">
            [[reviewContent]]
        </div>
    </div>
`;

$(".js-product-description-long").on('click', function (e) {
    e.preventDefault();
    $('.js-product-description').removeClass('smaller');
    $('.js-product-description-long').addClass('hidden');
    $('.js-product-description-less').removeClass('hidden');
});

$(".js-product-description-less").on('click', function (e) {
    e.preventDefault();
    $('.js-product-description').addClass('smaller');
    $('.js-product-description-long').removeClass('hidden');
    $('.js-product-description-less').addClass('hidden');
});

$('.review-bullet').each(function () {
    const text = $(this).find('span').text();
    let newText = '';
    try {
        newText = decodeURIComponent(text);
    } catch (e) {
        newText = text;
    }
    $(this).find('span').text(newText);
});

$(document).on('click', '.variant-filters .js-more', function (e) {
    e.preventDefault();
    const CONTAINER = $(this).parents('.product-variants');
    CONTAINER.find('.more-variants').removeClass('hidden');
    CONTAINER.find('.variant-thumbs').addClass('show-mobile');
    CONTAINER.find('.js-more').addClass('hidden');
    CONTAINER.find('.js-less').removeClass('hidden');
});

$(document).on('click', '.variant-filters .js-less', function (e) {
    e.preventDefault();
    const CONTAINER = $(this).parents('.product-variants');
    CONTAINER.find('.more-variants').addClass('hidden');
    CONTAINER.find('.variant-thumbs').removeClass('show-mobile');
    CONTAINER.find('.js-more').removeClass('hidden');
    CONTAINER.find('.js-less').addClass('hidden');
});


/**
 * Let's rethink this...
 * 
 * Every variant filter (.variant-option-text (div), .variant-filters--select (select)) has an attribute and an 'active' value
 * 
 * When user clicks on a filter, apply previously applied filters and do update. (call to backend)
 */


function getVariantFilterData(element) {
    let data = { attribute: '', value: '' };

    data['attribute'] =  $(element).parent().parent().attr('data-attribute') ? $(element).parent().parent().attr('data-attribute') : $(element).parent().parent().parent().attr('data-attribute');
    data['value'] =  $(element).attr('data-value');

    return data;
}


function doVariantFilterUpdate(event) {
    const $this = $(event.target);
    const _data = getVariantFilterData($this);

    var url = $('.variant-filters').attr('data-url');

    var attribute = _data['attribute'];

    var data = { attribute: attribute };
    var filters = {};

    var first = true;
    var append = true;

    $('.variant-filters [data-js="variant-filter"].selected, .variant-filters--select, .variant-thumb-img, [data-js="variant-filter-dropdown"]').each(function (index, el) {

        const _data = getVariantFilterData($(el));
        
        if (append) {
            filters[_data['attribute']] = _data['value'];
        } else {
            var replaceText = $(this).find('.product-variants').remove().end().find('[data-js="variant-filter-dropdown-selected"] span').attr('data-title');
            $(this).find('.product-variants').remove().end().find('[data-js="variant-filter-dropdown-selected"] span').text(replaceText);
            $(this).find('.product-variants').remove().end().find('[data-js="variant-filter-dropdown-selected"] img').remove();
            $(this).find('.product-variants').remove().end().removeClass('selected');
            $(this).find('.product-variants').remove().end().find('.selected').removeClass('selected');
            $(this).find('.product-variants').remove().end().find('._no-arrow').removeClass('_no-arrow');
            $('.pdp-mobile-padding .order-form button[type="submit"], .btn-green.js-trigger-original-orderform').attr("disabled", true)
            
            if (first) {
                first = false;
            } else {
                // do nothing yet?
            }
        }

        if (_data['attribute'] == attribute) {
            data['value'] = _data['value'];
            append = false;
        }
    });

    data['filters'] = filters;

    $.ajax({
        url: url,
        type: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(data),
        success: function (res) {
            // Result: 1 product
            if (res.url) {
                var url = res.url;
                $('.product-detail').css({ opacity: 0.5 });
                $('#js-loader-modal').modal({ keyboard: false });
                 window.location.href = url;

            }
            // Result: multiple variants
            if (res.html) {
                const orig_selectbox = document.querySelector(`[data-attribute='${res.attr}']`);

                if (orig_selectbox) {
                    orig_selectbox.outerHTML = `${res.html}`;
                }

                $('.variant-filters [data-js="variant-filter"]').off('variantfilter:change');
                $('.variant-filters--select').off('variantfilter:change');
                $('.variant-filters [data-js="variant-filter"]').on('variantfilter:change', function (e) { doVariantFilterUpdate(e); });
                $('.variant-filters--select').on('variantfilter:change', function (e) { doVariantFilterUpdate(e); });
            }
        }
    });
}

// Snapshot the original variant-filters HTML before any XHR mutations
var _variantFiltersOriginalHTML = null;
$(function () {
    var $vf = $('.variant-filters');
    if ($vf.length && $('#js-loader-modal').length) {
        _variantFiltersOriginalHTML = $vf.html();
    }
});

// Dismiss loader and restore original variant filter HTML when navigating back (bfcache restore)
window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    if (!$('#js-loader-modal').length || !$('.variant-filters').length) return;

    $('#js-loader-modal').modal('hide');
    $('.product-detail').css({ opacity: '' });
    $('.js-ga-addtocart').removeAttr('disabled');

    if (_variantFiltersOriginalHTML !== null) {
        $('.variant-filters').html(_variantFiltersOriginalHTML);
        // Re-bind event handlers on the restored DOM
        $('.variant-filters [data-js="variant-filter"]').on('variantfilter:change', function (e) { doVariantFilterUpdate(e); });
        $('.variant-filters--select').on('variantfilter:change', function (e) { doVariantFilterUpdate(e); });
    }
});

// Variant filters
$('.variant-filters [data-js="variant-filter"]').on('variantfilter:change', function (e) { doVariantFilterUpdate(e); });
$('.variant-filters--select').on('variantfilter:change', function (e) { doVariantFilterUpdate(e); });

$(document).on('click', '.variant-filters [data-js="variant-filter"]', function () {
    $(this).parent().parent().find('.selected').removeClass('selected');
    $(this).parent().parent().find('.current-product').remove();
    $(this).addClass('selected');
    $(this).trigger('variantfilter:change');
});

$('#prodAcc').on('shown.bs.collapse', function (e) {
    if ($(window).width() > 768) {
        $('html, body').animate({
            scrollTop: $(e.target).offset().top - 420
        }, 500);
    } else {
        $('html, body').animate({
            scrollTop: $(e.target).offset().top - 200
        }, 500);
    }
});

const getUserLocation = () => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            function (position) {
                const OUTLETS = [...document.querySelectorAll('.pdp-outlet.sidebar-button[data-lat][data-lon]')];

                if(OUTLETS.length) {
                    // supply every outlet with a distance relative to the user
                    OUTLETS.forEach(OUTLET => {
                        const OUTLET_LAT = parseFloat(OUTLET.dataset.lat) || 0;
                        const OUTLET_LON = parseFloat(OUTLET.dataset.lon) || 0;

                        OUTLET.dataset.distance = distance(position.coords.latitude, position.coords.longitude, OUTLET_LAT, OUTLET_LON, 'K');
                    });


                    // sort outlets based on the distance data-attribute
                    function outlet_sorter(a, b) {
                        if (parseFloat(a.dataset.distance) < parseFloat(b.dataset.distance)) return -1;
                        if (parseFloat(a.dataset.distance) > parseFloat(b.dataset.distance)) return 1;
                        return 0;
                    }

                    const SORTED_OUTLETS = OUTLETS.sort(outlet_sorter);

                    // get closest outlet
                    const CLOSEST_OUTLET = OUTLETS[0];

                    // add HTML to outlet when it's the closest
                    CLOSEST_OUTLET.classList.add('closest-outlet');
                    const CLOSEST_MESSAGE = document.createElement('span');
                    const CLOSEST_ICON = document.createElement('span');

                    CLOSEST_MESSAGE.classList.add('closest-message');
                    CLOSEST_MESSAGE.textContent = CLOSEST_OUTLET.dataset.closestText || 'Closest';

                    CLOSEST_ICON.classList.add('gorb');
                    CLOSEST_ICON.classList.add('gorb-winkel-pin-up2');

                    CLOSEST_MESSAGE.appendChild(CLOSEST_ICON);
                    CLOSEST_OUTLET.appendChild(CLOSEST_MESSAGE);
                }
            },
            function (position) {
                window.currentLocation = undefined
            }
        )
    }
};

function distance(lat1, lon1, lat2, lon2) {

    function deg2rad(deg) {
        return deg * (Math.PI / 180)
    }

    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1);  // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)
        ;
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
};

// if (document.querySelectorAll('.pdp-outlet.sidebar-button')) {
//     getUserLocation();
// }

function changePrice(quantity) {
    const SALE_PRICE_ELEMENT = $('.product-detail .order-form .price-sales[data-single-price]');
    const STANDARD_PRICE_ELEMENT = $('.product-detail .order-form .price-standard[data-single-price]');
    const DISCOUNT_ELEMENT = $('.product-detail .order-form .discount span');

    const F_FINAL_SALE_PRICE = parseFloat(parseFloat($(SALE_PRICE_ELEMENT).attr('data-single-price')) * parseFloat(quantity)).toFixed(2);
    const F_FINAL_STANDARD_PRICE = parseFloat(parseFloat($(STANDARD_PRICE_ELEMENT).attr('data-single-price')) * parseFloat(quantity)).toFixed(2);

    SALE_PRICE_ELEMENT.text(`${F_FINAL_SALE_PRICE}`.replace('.00', ',-').replace('.', ','));

    if (STANDARD_PRICE_ELEMENT && $(STANDARD_PRICE_ELEMENT).attr('data-single-price'))
        STANDARD_PRICE_ELEMENT.text(`${F_FINAL_STANDARD_PRICE}`.replace('.00', ',-').replace('.', ','));

    if (DISCOUNT_ELEMENT)
        DISCOUNT_ELEMENT.text(`${parseFloat(F_FINAL_STANDARD_PRICE - F_FINAL_SALE_PRICE).toFixed(2)}`.replace('.00', ',-').replace('.', ','));
}
$(document).on('click', '.js-input-decrease', function (e) {
    e.preventDefault();
    const Input = $(this).parent().find('.js-quantity-input');
    if (Input.length) {
        Input[0].stepDown();
        Input.trigger('change');
    }
    $(this).parents().find('button[type="submit"]').removeClass('js-add-oneitem');
});

$(document).on('click', '.js-input-increase', function (e) {
    e.preventDefault();
    const Input = $(this).parent().find('.js-quantity-input');
    if (Input.length) {
        Input[0].stepUp();
        Input.trigger('change');
    }

    $(this).parents().find('button[type="submit"]').removeClass('js-add-oneitem');
});

$('.js-quantity-input').on('change', function (e) {
    var $this = $(this);
    $this.attr('disabled', true);
    var url = $this.attr('data-url'),
        quantity = $this.val(),
        memo = $this.closest('.basket-product').find('.memofield').val();

        history.replaceState(null, null, ' ');

    $.get(url, { quantity: quantity, memo: memo }, function (data) {
        setTimeout(function(){ 
            window.location.href = window.location.href;
            $('#js-loader-modal').modal({ keyboard: false });

        }, 500)
    });
});


function initReadMore() {
    $(document).on('click', '.js-read-more-toggle', function (e) {
        var content = $(this).parents('.gs-read-more-widget').find('.js-read-more-content');
        content.toggleClass('small');
        $(this).find('.go').toggleClass('rotate');
        if (content.hasClass('small')) {
            $(this).find('span div, span span, .inner-text').text($(this).attr('data-open-text'))
        } else {
            $(this).find('span div, span span, .inner-text').text($(this).attr('data-close-text'))
        }
    });
}

$('.js-trigger-original-orderform').on('click', function (e) {
    $('.product-detail .atc-wrapper .order-form [type="submit"]').trigger('click');
});

defer([initReadMore]);

const ALL_POPOVERS = document.querySelectorAll('.cs-popover-toggle');

ALL_POPOVERS.forEach(popover => {
    popover.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        if (popover.dataset.target && document.querySelector(popover.dataset.target)) {
            const POPOVER = document.querySelector(popover.dataset.target);
            POPOVER.classList.toggle('open');
        }
    });
});

const SPECS_TOGGLE = document.querySelectorAll('.product-specifications .background-gradient');

SPECS_TOGGLE.forEach(toggle => {
    toggle.addEventListener('click', function (e) {
        toggle.parentElement.classList.add('in');
    });
});

const FAQ_BUTTON = document.getElementById('faq-button');
if (FAQ_BUTTON) {
    const BACKUP_ICON = FAQ_BUTTON.querySelector('i');

    FAQ_BUTTON.addEventListener('click', function (e) {
        if (FAQ_BUTTON.textContent == FAQ_BUTTON.dataset.readLessText) {
            FAQ_BUTTON.textContent = FAQ_BUTTON.dataset.readMoreText;
        } else {
            FAQ_BUTTON.textContent = FAQ_BUTTON.dataset.readLessText;
        }
        BACKUP_ICON.classList.toggle('fa-rotate-180');
        FAQ_BUTTON.append(BACKUP_ICON);
    });
}

$('.js-toggle-360').on('click', function () {
    if ($('.vivition-360').hasClass('_hack-on')) {
        $('.vivition-360').removeClass('_hack-on');
    } else {
        $('.vivition-360').addClass('_hack-on');
    }
});

$('.js-toggle-video').on('click', function () {
    $('.product-video-container').toggleClass('_hack-on');
});

$('.js-hide-360').on('click', function () {
    if (!$('.vivition-360').hasClass('_hack-on')) {
        $('.vivition-360').addClass('_hack-on');
    }
});

const calcSlidesPerViewAlt = (element, initial) => {
    let slides = initial || 5;
    const final_element = document.querySelector(element);

    if (final_element && final_element.classList.contains('has-video')) {
        slides -= 1;
    }

    return slides;
}

if ($('.js-product-image-slider').length) {
    const altImageProductSlider = new Swiper('.js-product-alt-image-slider', {
        passiveListeners: false,
        spaceBetween: 10,
        slidesPerView: calcSlidesPerViewAlt('.js-product-image-slider', 5),
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        navigation: {
            nextEl: '.swiper-next-btn',
            prevEl: '.swiper-prev-btn'
        },
        breakpoints: {
            992: {
                slidesPerView: calcSlidesPerViewAlt('.js-product-image-slider', 6)
            },
        }
  
    });

    $('.js-product-alt-image-slider div[data-slide]').on('click', function (e) {
        e.preventDefault();
        var slideno = $(this).data('slide');
        mainProductSlider.slideTo(slideno);
    });

    const mainProductSlider = new Swiper('.js-product-image-slider', {
        slidesPerView: 1,
        centeredSlides: true,
        preloadImages: false,
        lazy: true,
        navigation: ($('.js-product-alt-image-slider').length ? {
            nextEl: '.swiperNext',
            prevEl: '.swiperPrev',
        } : false),
        pagination: ($('.js-product-alt-image-slider').length ? {
            el: '.slick-dots',
        } : false),
        thumbs: ($('.js-product-alt-image-slider').length ? {
            swiper: altImageProductSlider,
        } : false),
        on: {
            slideChange(swiper) {
                $('.product-video-container, .vivition-360').addClass('_hack-on');
            }
        }
    });
}
if ($('.js-misc-products-slider').length) {
    const miscProductsSlider = new Swiper('.js-misc-products-slider', {
        passiveListeners: false,
        spaceBetween: 10,
        slidesPerView: 1,
        watchOverflow: true,
        pagination: {
            el: ".slider-pagination",
            clickable: true
        },
        breakpoints: {
            480: {
                slidesPerView: 2.5,
                spaceBetween: 10,
            },
            640: {
                slidesPerView: 2.5,
                spaceBetween: 10,
            },
            992: {
                slidesPerView: 4,
                spaceBetween: 25,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 25,
            }
        }
    });
}

if ($('.js-promotion-slider').length) {
    const recentProductsSlider = new Swiper('.js-promotion-slider', {
        passiveListeners: false,
        spaceBetween: 10,
        slidesPerView: 1.35,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
            dragSize: 'auto'
        },        
        breakpoints: {
            480: {
                slidesPerView: 1.35,
                spaceBetween: 10,
            },
            992: {
                slidesPerView: 5,
                spaceBetween: 25,
            },
            1200: {
                slidesPerView: 5,
                spaceBetween: 25,
            }
        }
    });
}

if ($('#default-carousel').length) {
    const defaultCarousel = new Swiper('#default-carousel', {
        passiveListeners: false,
        slidesPerView: 1,
        speed: 500,
        watchOverflow: true,
        pagination: {
            el: ".default-carousel__indicator",
            clickable: true
        },
        navigation: {
            nextEl: '.default-carousel__navigation-next',
            prevEl: '.default-carousel__navigation-prev'
        },
        breakpoints: {
            768: {
                speed: 1500
            }
        }
    });
}

/////video-carousel//////
const videosCarousel = document.querySelectorAll('[data-js-video-carousel]');

if (videosCarousel.length) {
    videosCarousel.forEach( carousel => {
        hidePreloadImage(carousel);
        let swiper = new Swiper(carousel, {
            passiveListeners: false,
            slidesPerView: 1,
            speed: 1500,
            watchOverflow: true,
            pagination: {
                el: ".default-carousel__indicator",
                clickable: true
            },
            navigation: {
                nextEl: '.default-carousel__navigation-next',
                prevEl: '.default-carousel__navigation-prev'
            }
        })
    }
)}

function hidePreloadImage(container) {
    const slides = container.querySelectorAll('.swiper-slide');
    slides.forEach((slide) => {
        const media = slide.dataset.mediaType;
        if (media == "video") {
            const image = slide.querySelector('.vc-preload-image');
            const iframe = slide.querySelector('iframe');
            const iframeDiv = slide.querySelector('.vc-wrapper-iframe');
            if(!iframe) return;
            iframe.onload = function() {
                setTimeout(() => {
                image.classList.add('hidden');
                iframeDiv.classList.remove('hidden');
                }, 500);
            }
        }
    })
}

// function setPaddingsVideoCarousel() {
//     const iframes = document.querySelectorAll('.vc-wrapper-iframe');
//     if (iframes.length) {
//         iframes.forEach(item => {
//             if (item.dataset.paddingsMobile) {
//                 const paddings = item.getAttribute('[data-paddings]');
//                 const paddingsMobile = item.getAttribute('[data-paddings-mobile]');
//                 if ($(window).width() < 768) {
//                     item.style.padding = paddingsMobile;
//                 } else {
//                     item.style.padding = paddings;
//                 }
//             }
//         })
//     }
// }
// setPaddingsVideoCarousel();
// window.addEventListener('resize', function() {
//     setPaddingsVideoCarousel();
// }, true);

/////video-carousel//////

const PDP_NAV_ELEMENT = document.querySelector('.js-pdp-nav-container');
const PDP_NAV = PDP_NAV_ELEMENT ? new Swiper(PDP_NAV_ELEMENT, {
    slidesPerView: 'auto',
    spaceBetween: 15,
    navigation: {
        nextEl: '#pdp-nav-next',
        prevEl: '#pdp-nav-prev',
    }
}) : null;

$(document).on('submit', '.order-form', e => { e.preventDefault(); });

// Get basket count cookie
function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

function deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
}

function getBasketCount() {
    
    setTimeout(() => {
        var myCookie = getCookie('cs_basket_count');
        var basketCount = document.querySelectorAll('.js-basketcount');
        if (myCookie && myCookie > 0 ) {
            basketCount.forEach(function(element) {
                if (myCookie > 99 ) {
                    element.querySelector('span').innerHTML = '99+';
                }else {
                    element.querySelector('span').innerHTML = myCookie;
                }
                element.classList.add('badge');
            });
        }
   
    }, 500);
}

getBasketCount();

$('.js-clear-basketcount').on('click', function() {
    deleteCookie('cs_basket_count');
});


$(function () {
    const resetButtonToDefault = (button) => {
        if (button) {
          button.removeClass('_call-pending');
          button.removeClass('_call-success');
          button.removeClass('_call-error');
        }
      };
    
      const setButtonState = (button, state) => {
        if (button && state) {
          resetButtonToDefault(button);
    
          switch (state) {
            case 'success':
              button.addClass('_call-success');
              break;
            case 'pending':
              button.addClass('_call-pending');
              break;
            case 'error':
              button.addClass('_call-error');
              break;
            default:
              break;
          }
        }
    };

    var basket_products;
    
    $(document).off('submit', '.order-form');
    $(document).off('click', '.order-form button[type=submit], .js-order-form button[type=submit]');
    $(document).on('click', '.order-form button[type=submit], .js-order-form button[type=submit]', function (e) {
        var submit_btn = $(this);
        var form = submit_btn.parents('form'),
            url = form.prop('action'),
            view_func = form.data('view-func'),
            product = form.find('input[name=product]').val(),
            contract_id = form.find('input[name=contract_id]').val(),
            thum = form.find('input[name=thum]').val(),
            con = form.find('input[name=con]').val(),
            quantity_input = form.find('input[name=quantity]'),
            quantity = quantity_input.val(),
            old_quantity = quantity,
            detail = $(".js-ga-product-detail"),
            ega = form.closest('[data-ega]').data('ega'),
            memo = $('input[name=memo]').val(),
            error = form.find('.js-error-message'),
            template_input = form.find('input[name=template_state]'),
            template_state = template_input.length ? template_input.val() : 0;

        // loader icon
        if (submit_btn.hasClass('js-order-loader')) {
            submit_btn.addClass('loader-visible');
        }

        // product options
        var options = [];

        $('.product-option').each(function (index, item) {
            var checkbox = $(item).find('.js-option-input');
            var quantity = $(item).find('.js-option-quantity');
            if ($(checkbox).is(':checked')) {
                options.push({
                    id: $(checkbox).attr('data-id'),
                    quantity: $(quantity).val()
                });
            }
        });

        options = JSON.stringify(options);

        function getConfiguratorFormData($form) {
            var unindexed_array = $form.serializeArray();
            var indexed_array = {};
            $.map(unindexed_array, function (n, i) {
                if (n['name'].substring(0, 4) == 'text') {
                    if (n['value'] != '') {
                        if (!indexed_array['text']) indexed_array['text'] = [];
                        indexed_array['text'].push(n['value']);
                    }
                } else {
                    indexed_array[n['name']] = n['value'];
                }
            });
            return indexed_array;
        }

        // print configuration
        var configuration_form = $('.js-configurator-form');
        //remove below if statement after all themes are transisioned to new css/js class split
        if (configuration_form == undefined || configuration_form.length == 0) {
            configuration_form = $('#configurator-form');
        }

        var configuration = configuration_form.length ? getConfiguratorFormData(configuration_form) : {};
        configuration = JSON.stringify(configuration);

        // product configuration
        var configurator_payload = $('.js-configurator-payload');
        //remove below if statement after all themes are transisioned to new css/js class split
        if (configurator_payload == undefined || configurator_payload.length == 0) {
            configurator_payload = $('#configurator-payload');
        }

        var product_configuration = configurator_payload.data('value');

        // upload configuration
        var upload_configuration = ""
        if ($('#image-upload-configuration').length) {
            upload_configuration = form.find('input[name=image_upload_configuration]').val()
        }

        // Add one item from PLP
        if (submit_btn.hasClass('js-add-oneitem')) {
            var new_current_quantity = parseFloat(quantity) + 1;
            var quantity = new_current_quantity;
        }

        setButtonState(submit_btn, 'pending');

        if (view_func == 'basket.index') {
            $('#js-loader-modal').modal({ keyboard: false });
        }


        $.post(url, {
            product: product,
            quantity: quantity,
            options: options,
            configuration: configuration,
            contract_id: contract_id,
            product_configuration: product_configuration,
            memo: memo,
            upload_configuration: upload_configuration,
            template_state: template_state,
            thum: thum,
            con: con
        }, function (data) {
            // redirect to basket
            if (data.action) {
                window.location.href = data.action;
            }

            if (submit_btn.hasClass('js-order-loader')) {
                submit_btn.removeClass('loader-visible');
            }

            // everything good
            if (data.result && data.result.status) {
                if (view_func == 'basket.index') {
                    if (history.scrollRestoration) {
                        history.scrollRestoration = 'manual';
                    } else {
                        window.onbeforeunload = function () {
                            window.scrollTo(0, 0);
                        }
                    }
                    window.location.reload();
                }

                setButtonState(submit_btn, 'success');

                basket_products = data.result.basket.products;

                getBasketCount();
                // form.replaceWith(data.result.html);
                // $('.js-basket-small').replaceWith(data.result.b1);
                $('.js-basket-large').replaceWith(data.result.b2);
                $('.js-basket-large #recent-products .row').replaceWith($('#recent-products-template .row'));
                             
                if (old_quantity <= quantity) {
                    EEC._addToCart(old_quantity, quantity, ega, submit_btn);
                } else {
                    EEC._removeFromCart(old_quantity, quantity, ega);
                }

                var reload_preview = function () {
                    $('#js-order-modal').modal('hide');
                    $('#js-order-modal').hasClass('in') ?
                        () => { } :
                        $('#js-order-modal').modal({ 'show': true });
                }


                // PREVIEW AFTER BASKET ADD
                if (typeof (BASKET_PREVIEW_ADD) !== 'undefined') {
                    var bp = $('.js-basket-preview');
                    //remove below if statement after all themes are transisioned to new css/js class split
                    if (bp == undefined || bp.length == 0) {
                        bp = $('.basket-preview');
                    }

                    var url = bp.attr('data-url');
                    if (url) {
                        $.ajax({
                            type: 'get', url: url, cache: false,
                            success: function (data) {
                                bp.html(data);
                            }
                        });
                        $('.header .basket, .js-header .js-basket').addClass('preview');
                        bp.show();
                        $('body').click(function (evt) {
                            if ($(evt.target).hasClass('basket-preview')) {
                                return;
                            }
                            // for descendants
                            if ($(evt.target).closest('.basket-preview').length || $(evt.target).closest('.js-basket-preview').length) {
                                return;
                            }
                            $('.header .basket, .js-header .js-basket').removeClass('preview');
                        });
                    }

                }

                if (typeof (QUANTITY_SPINNER) !== 'undefined') {
                    initNumericStepper();
                }

                // display modal
                if (data.result.modal && view_func !== 'basket.index') {
                   
                    $('body').append(data.result.modal);

                    const product_options = document.querySelectorAll('[data-js-product-options]');
                    let product_option_item_id;
                    
                    if (product_options.length) {
                        product_options.forEach(option => {
                            let option_url = option.parentElement.dataset.action;
    
                            if (basket_products) {
                                basket_products.forEach(product => {
                                    if ( option.parentElement.dataset.id == product.id ) {
                                        product_option_item_id = product.item_id;
                                        return product_option_item_id;
                                    }
                                })
                            }
                            if (product_option_item_id) {
                                const replace_id = option_url.replace(/\D/g,''); // Find ID in action
                                const newOptionAction = option_url.replace(replace_id, product_option_item_id); // Replace ID;
                                    
                                if (replace_id != product_option_item_id) {
                                    option.parentElement.setAttribute('data-action', newOptionAction);
                                    option_url = option.parentElement.dataset.action;
                                }
                            }
                        });
                    }

                    setTimeout(() => {
                        const productAddons = document.querySelector('#addons-carousel');
                        
                        if(productAddons) {
                            const swiper = new Swiper(productAddons, {
                                passiveListeners: false,
                                slidesPerView: 2.4,
                                speed: 1500,
                                watchOverflow: true,
                                spaceBetween: 15,
                                init: false,
                                navigation: {
                                    nextEl: productAddons.parentNode.querySelector('.swiper-navigation-next'),
                                    prevEl: productAddons.parentNode.querySelector('.swiper-navigation-prev'),
                                }
                            });
       
                            if (window.innerWidth > 992) {
                                swiper.init();
                            }
                        }
                    }, 100);
                }

                reload_preview();
            }

            setTimeout(() => {
                resetButtonToDefault(submit_btn);
                submit_btn.blur();
              }, 1000);

            // problem
            if (data.result && !data.result.status) {
                error.removeClass('hidden');
                error.find('.alert').html(data.result.message);
                quantity_input.val(data.result.quantity);
                setButtonState(submit_btn, 'error');
            }
        }).fail(function (error) {
            const optionsFlashMessage = { type: 'info', 
            z_index: 99999999, placement: { from: 'bottom', align: 'right' } };
            const errorMessage = JSON.parse(error.responseText).message
            if (error.status === 400 && errorMessage) {
                $.notify({ message: errorMessage }, optionsFlashMessage)
            }
        });

        return false;
    });


    $('.product-item .js-delete').on('click', function(e) {
        e.preventDefault();
        const EGA = $(this).parent().data('ega');

        EEC._removeFromCart(EGA.qty, 0, EGA);

        window.location.href = $(this).attr('href');
    })

    $('.js-ga-update-quantity').on('click', async function(e) {
        var form = $(this).parents('.order-form').length ? $(this).parents('.order-form') : $(this).parents('.basket-product-quantity-container'),
        detail = $(".js-ga-product-detail"),
        ega = detail.length ? detail.data("ega") : form.data('ega'),
        quantity = $(form).find("input[name=quantity]"),
        oldQuantity = $(form).find("input[name=current_quantity]");
        let oldQty;
        let newQty;

        const request = await api.get($(this).parents().data("tree-parents-url").replace('999999', ega.treeID))
        .then((trees) => {
            return trees.map(tree => tree.name).join('/');
        });
        

        ega['category'] = `${request}/${ega.tree_name}`;

        $(this).attr('data-ega', JSON.stringify(ega))

       
        if ($(this).hasClass('js-ga-add-to-basket')) {
            oldQty = oldQuantity.val();
            newQty = +oldQty + 1;
            setTimeout(() => {
                EEC._addToCart(oldQty, newQty, ega);
            }, 300);
        }else if ($(this).hasClass('js-ga-remove-from-basket')) {
            oldQty = oldQuantity.val();
            newQty = oldQty - 1;
            setTimeout(() => {
                EEC._removeFromCart(oldQty, newQty, ega);
            }, 300);
        }
    });

    $(document).on('click', '.js-ga-removefromcart', async function (e) {
        const ega =  $(this).closest(".js-ga-basket-product").data("ega"),
        quantity = ega?.qty;
        const oldQty = quantity;
        const newQty = 0;

        if (ega.treeID) {
            const request = await api.get($(this).closest(".js-ga-basket-product").data("tree-parents-url").replace('999999', ega.treeID))
            .then((trees) => {
                return trees.map(tree => tree.name).join('/');
            });

            ega['category'] = `${request}/${ega.tree_name}`;
        } 
        
        $(this).closest(".js-ga-basket-product").attr('data-ega', JSON.stringify(ega))

        setTimeout(() => {
            EEC._removeFromCart(oldQty, newQty, ega);
        }, 300);

        $('#js-loader-modal').modal({ keyboard: false });
        const dataURL = $(this).data("url");

        fetch(dataURL, { 
            method: 'GET'
        }).then(() => {
            window.location.reload();
        }).catch(err => {
            console.error(err) 
        });
    
    });

    let OPTIONS_DATA = [];
    document.addEventListener('change', (event) => {
        if (event.target.closest('.order-modal__pcs--action')) {
            postDataWarranty(event);
        }
    });
   
    const btnRemove = document.querySelector('.product-options--remove-warranty label');
    if (btnRemove) {
        btnRemove.addEventListener('click', (event) => {
            postDataWarranty(event);
        });
    }

    function postDataWarranty(event) {
        const OPTION_SELECTOR = event.target;
        if (!OPTION_SELECTOR) return;
        const removeBtn = document.querySelector('.product-options--remove-warranty');
        const OPTION_TARGET = OPTION_SELECTOR.matches('[data-js-product-options]');
        let OPTION_SELECTOR_URL = OPTION_SELECTOR.parentElement.dataset.action;
        let FORM_DATA = []
        const OPTIONS_DATA = []
       
        if (OPTION_TARGET) {
            if (OPTION_SELECTOR.checked) {
                OPTIONS_DATA.push({'id': OPTION_SELECTOR.dataset.id, 'quantity': 1});
                removeBtn.classList.remove("hidden");
                OPTION_SELECTOR.nextElementSibling.querySelector('.add').classList.add('hidden');
                OPTION_SELECTOR.nextElementSibling.querySelector('.added').classList.remove('hidden');
            }
        } else {
            OPTIONS_DATA.push({'id': OPTION_SELECTOR.parentElement.dataset.id, 'quantity': 0});
            if (removeBtn) {
                removeBtn.classList.add("hidden");
            }
            OPTION_SELECTOR.parentElement?.parentElement?.querySelector('.add')?.classList.remove('hidden');
            OPTION_SELECTOR.parentElement?.parentElement?.querySelector('.added')?.classList.add('hidden');
        }

        FORM_DATA = JSON.stringify(OPTIONS_DATA);

        $.ajax({
            type: 'POST',
            url: OPTION_SELECTOR_URL,
            data: FORM_DATA,
            contentType: 'application/json',
            dataType: 'json',
            success: function (res) {
                console.log(res)
            }
        });
    };
});

const btnMore = document.querySelector('[data-js-stofstaal-more]');

const loadStofstallen = (e) => {
    const stofstallen = document.querySelectorAll('[data-js-load-stofstaal');
    e.currentTarget.classList.add('hidden');

    stofstallen.forEach(item => {
        if (item.classList.contains('hidden-xs')) {
            item.classList.remove('hidden-xs')
        }
    });

}

if (btnMore) {
    btnMore.addEventListener('click', (e) => loadStofstallen(e));
}

function productVariants() {
    const calledUnknownImages = new Set();
  
    const variants = [...document.querySelectorAll('[data-js="product-variant"][data-img]')];
  
    const verifyImageExists = async (imageSource) => {
      return await fetch(imageSource).then(data => data.ok);
    }

    variants.forEach((variant) => {
      const product = variant.closest('.product');
      if (!product) { return;  }
      const target = product.querySelector('[data-js-product-variant-target]');
      const { img } = variant.dataset;
      const initialSrc = target ? target.getAttribute('src') : '';
  
      if (!target || !img) { return; }
  
      const leaveHandler = () => {
        target.setAttribute('src', initialSrc);
      }
  
      variant.addEventListener('mouseleave', leaveHandler);
  
      const enterHandler = async () => {
        const removeListeners = () => {
          variant.removeEventListener('mouseenter', enterHandler);
          variant.removeEventListener('mouseenter', leaveHandler);
        }
  
        if (calledUnknownImages.has(img)) { return; }
  
        if (!(await verifyImageExists(img))) {
          calledUnknownImages.add(img);
          removeListeners();
          return;
        }
  
        target.setAttribute('src', img);
      }
  
      variant.addEventListener('mouseenter', enterHandler);
    });
  
  }

const button = document.querySelectorAll('[data-js-ga-from-price]');;

if (button.length > 0) {
    button.forEach(btn => {
        btn.addEventListener('click', (e) => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': "PDP vanaf prijs informatie "
            });
        });
    });
}

productVariants();

setTimeout(() => {
    const total = document.querySelector('.data-js-basket-count')?.value;
    if (total && total > 0) {
        document.cookie = `cs_basket_count=${total}; path=/"`;
    }
},500)